import React, { useEffect, useState } from "react"
import { Card, CardBody, Table } from "reactstrap"
import { fetchData, fetchNodeData } from "utils/common-fetchData"
import zithas from "../../../assets/images/main-zithas.png"
import { Tooltip } from "antd"
import { convertSecondsToTime, getInitials } from "utils/common-helpers"
import Loader from "pages/Separate/Loader"
import configure from "configure"
import secureLocalStorage from "react-secure-storage"
import moment from "moment"

const WorkDuration = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const toggleLoading = loading => {
    setLoading(loading)
  }
  const getWork = async () => {
    const response = await fetchNodeData(
      toggleLoading,
      "workDuration",
      secureLocalStorage.getItem("auth_token")
    )
    console.log("ajscbajscbsdh: ", response)
    if (response?.success) {
      setData(response?.data)
    }
  }
  useEffect(() => {
    getWork()
  }, [])
  function getPreviousDate() {
    const today = new Date()
    today.setDate(today.getDate() - 1)
    return today
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div>
        <Card>
          <CardBody>
            <div className="mb-4 d-flex justify-content-between">
              <p className="text-purple fs-5 mb-0 fw-bold">Work Duration</p>
              <div className="text-purple absent-length">{data?.length}</div>
            </div>
            <div className="responsive-table mb-4">
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th className="header col-2">User</th>
                    <th className="header col-5">Date</th>
                    <th className="text-center header col-4">Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((obj, i) => {
                    return (
                      <tr key={i}>
                        <td>
                          {obj?.avatar ? (
                            <Tooltip color={"#752b97"} title={obj?.name}>
                              <img
                                src={`${
                                  obj?.avatar != null
                                    ? `${configure.imgUrl}${obj?.avatar}`
                                    : zithas
                                } `}
                                alt="user Image"
                                className="img-fluid cursor-pointer object-fit-cover"
                                style={{
                                  borderRadius: "50px",
                                  width: "30px",
                                  height: "30px",
                                }}
                                title={obj?.name}
                              />
                            </Tooltip>
                          ) : (
                            <div className="defualt-img " title={obj?.name}>
                              {getInitials(obj?.name || "Z")}
                            </div>
                          )}
                        </td>
                        <td>
                          {" "}
                          {moment(getPreviousDate()).format("DD-MM-YYYY")}
                        </td>
                        <td className="text-center">
                          {obj?.total_time_today}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
              {data?.length == 0 ? (
                <p className="text-center text-purple fw-bold mt-3">
                  🎉 Everyone's working hard! No durations under 5 hours! 💪
                </p>
              ) : null}
            </div>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  )
}

export default WorkDuration
